<template>
  <div>
    <funcionalidade-header
      :titulo="funcionalidade.nome">
    </funcionalidade-header>
    <ErrorLayout
      :showBtn="false"
      :texto="texto"
      :titulo="titulo">
    </ErrorLayout>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ErrorLayout from '@/components/Error/ErrorLayout'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
export default {
  name: 'FuncDefault',
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    titulo () {
      return `Funcionalidade não implementada`
    },
    texto () {
      return `Essa funcionalidade está sendo desenvolvida e em breve estará disponível`
    }
  },
  components: {
    ErrorLayout,
    FuncionalidadeHeader
  }
}
</script>

<style scoped>
.my-code > pre code {
  background-color: #eee;
  border: 1px solid #999;
  display: block;
  padding: 10px;
  white-space: break-spaces;
}
</style>
